import { useEffect, useState } from 'react';

/** How often "today" and "now" are re-read from the browser clock. */
const TICK_MS = 30_000;

/** The current time, refreshed every half minute (for marking today and the running lesson). */
export function useNow(): Date {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = window.setInterval(() => setNow(new Date()), TICK_MS);
    return () => window.clearInterval(id);
  }, []);
  return now;
}

/** Fullscreen state of the page plus a toggle; needs a user gesture, hence a button. Escape leaves natively. */
export function useFullscreen(): { fullscreen: boolean; toggle: () => void } {
  const [fullscreen, setFullscreen] = useState(false);
  useEffect(() => {
    const onChange = () => setFullscreen(document.fullscreenElement !== null);
    document.addEventListener('fullscreenchange', onChange);
    return () => document.removeEventListener('fullscreenchange', onChange);
  }, []);
  const toggle = () => {
    const request = document.fullscreenElement ? document.exitFullscreen() : document.documentElement.requestFullscreen();
    request.catch(() => undefined);
  };
  return { fullscreen, toggle };
}
